<style>
  .container-gauge{
    height: 300px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/energy/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
    <vs-tabs>
      <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
      <vx-card
          title="Últimas Lecturas">
              <div style="width: 100%">
                <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            <vs-table v-if="response" ref="table" :data="response">
            <template slot-scope="{data}">
              <tbody>
                <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                  <table>
                    <tr>
                    <listItem
                      :value="item.created_at"
                      :description="$t('Labels.Date')"
                      img="fecha"
                    ></listItem>
                    <listItem
                      :value="item.created_at"
                      :description="$t('Labels.LastUpdated')"
                      img="clock"
                      :relativeTime="true"
                    ></listItem>
                    </tr>
                    <tr v-if="item.id_trama == '0'">
                      <listItem
                        :value="item.corriente_a"
                        :description="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                        img="corriente_a"
                        unit="A"
                      ></listItem>
                      <listItem
                        :value="item.voltaje_a"
                        :description="$tc('Labels.Voltage', 2, { n: 'A' })"
                        img="voltaje_a"
                        unit="V"
                      ></listItem>
                      <listItem
                        :value="item.potencia_a"
                        :description="$tc('Labels.Power', 2, { n: 'A' })"
                        img="potencia_a"
                        unit="W"
                      ></listItem>
                      <listItem
                        :value="item.factor_a"
                        :description="$tc('Labels.Factor', 2, { n: 'A' })"
                        img="factor_a"
                      ></listItem>
                    </tr>
                    <tr v-if="item.id_trama == '0'">
                      <listItem
                        :value="item.corriente_b"
                        :description="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                        img="corriente_b"
                        unit="A"
                      ></listItem>
                      <listItem
                        :value="item.voltaje_b"
                        :description="$tc('Labels.Voltage', 2, { n: 'B' })"
                        img="voltaje_b"
                        unit="V"
                      ></listItem>
                      <listItem
                        :value="item.potencia_b"
                        :description="$tc('Labels.Power', 2, { n: 'B' })"
                        img="potencia_b"
                        unit="W"
                      ></listItem>
                      <listItem
                        :value="item.factor_b"
                        :description="$tc('Labels.Factor', 2, { n: 'B' })"
                        img="factor_b"
                      ></listItem>
                    </tr>
                    <tr v-if="item.id_trama == '0'">
                      <listItem
                        :value="item.corriente_c"
                        :description="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                        img="corriente_c"
                        unit="A"
                      ></listItem>
                      <listItem
                        :value="item.voltaje_c"
                        :description="$tc('Labels.Voltage', 2, { n: 'C' })"
                        img="voltaje_c"
                        unit="V"
                      ></listItem>
                      <listItem
                        :value="item.potencia_c"
                        :description="$tc('Labels.Power', 2, { n: 'C' })"
                        img="potencia_c"
                        unit="W"
                      ></listItem>
                      <listItem
                        :value="item.factor_c"
                        :description="$tc('Labels.Factor', 2, { n: 'C' })"
                        img="factor_c"
                      ></listItem>
                    </tr>
                    <tr v-if="item.id_trama == '1'">
                      <listItem
                        :value="item.energia"
                        :description="$tc('Labels.Energy')"
                        img="kws"
                        unit="Wh"
                      ></listItem>
                      <listItem
                        :value="item.energia_a"
                        :description="$tc('Labels.Energy', 2, { n: 'A' })"
                        img="kws"
                        unit="Wh"
                      ></listItem>
                      <listItem
                        :value="item.energia_b"
                        :description="$tc('Labels.Energy', 2, { n: 'B' })"
                        img="kws"
                        unit="Wh"
                      ></listItem>
                      <listItem
                        :value="item.energia_c"
                        :description="$tc('Labels.Energy', 2, { n: 'C' })"
                        img="kws"
                        unit="Wh"
                      ></listItem>
                    </tr>
                  </table>
                </tr>
              </tbody>
            </template>
          </vs-table>

      </vx-card>
      </vs-tab>
      <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
        <vs-switch v-model="activeRefresh">
          <span slot="on">{{$t('Labels.Refresh')}}</span>
          <span slot="off">No {{$t('Labels.Refresh')}}</span>
        </vs-switch>
        <div class="flex mt-12" v-if="showGauges">
          <div class="flex-1 p-4">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.corriente.min"
                :max="limits.corriente.max"
                :alertMin="gauges.min_corriente_a"
                :alertMax="gauges.max_corriente_a"
                :title="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                :value="gauges.corriente_a"
                unit="A"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.corriente.min"
                :max="limits.corriente.max"
                :alertMin="gauges.min_corriente_b"
                :alertMax="gauges.max_corriente_b"
                :title="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                :value="gauges.corriente_b"
                unit="A"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.corriente.min"
                :max="limits.corriente.max"
                :alertMin="gauges.min_corriente_c"
                :alertMax="gauges.max_corriente_c"
                :title="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                :value="gauges.corriente_c"
                unit="A"
              />
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showGauges">
          <div class="flex-1 p-4">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia.min"
                :max="limits.potencia.max"
                :alertMin="gauges.min_potencia_a"
                :alertMax="gauges.max_potencia_a"
                :title="$tc('Labels.Power', 2, { n: 'A' })"
                :value="gauges.potencia_a"
                unit="W"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia.min"
                :max="limits.potencia.max"
                :alertMin="gauges.min_potencia_b"
                :alertMax="gauges.max_potencia_b"
                :title="$tc('Labels.Power', 2, { n: 'B' })"
                :value="gauges.potencia_b"
                unit="W"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia.min"
                :max="limits.potencia.max"
                :alertMin="gauges.min_potencia_c"
                :alertMax="gauges.max_potencia_c"
                :title="$tc('Labels.Power', 2, { n: 'C' })"
                :value="gauges.potencia_c"
                unit="W"
              />
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showGauges">
          <div class="flex-1 p-4">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.voltaje.min"
                :max="limits.voltaje.max"
                :alertMin="gauges.min_voltaje_a"
                :alertMax="gauges.max_voltaje_a"
                :title="$tc('Labels.Voltage', 2, { n: 'A' })"
                :value="gauges.voltaje_a"
                unit="V"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.voltaje.min"
                :max="limits.voltaje.max"
                :alertMin="gauges.min_voltaje_b"
                :alertMax="gauges.max_voltaje_b"
                :title="$tc('Labels.Voltage', 2, { n: 'B' })"
                :value="gauges.voltaje_b"
                unit="V"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.voltaje.min"
                :max="limits.voltaje.max"
                :alertMin="gauges.min_voltaje_c"
                :alertMax="gauges.max_voltaje_c"
                :title="$tc('Labels.Voltage', 2, { n: 'C' })"
                :value="gauges.voltaje_c"
                unit="V"
              />
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showGauges">
          <div class="flex-1 p-4">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia_r.min"
                :max="limits.potencia_r.max"
                :alertMin="gauges.min_potencia_r_a"
                :alertMax="gauges.max_potencia_r_a"
                :title="$tc('Labels.ReactivePower', 2, { n: 'A' })"
                :value="gauges.potencia_r_a"
                unit="VAR"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia_r.min"
                :max="limits.potencia_r.max"
                :alertMin="gauges.min_potencia_r_b"
                :alertMax="gauges.max_potencia_r_b"
                :title="$tc('Labels.ReactivePower', 2, { n: 'B' })"
                :value="gauges.potencia_r_b"
                unit="VAR"
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.potencia_r.min"
                :max="limits.potencia_r.max"
                :alertMin="gauges.min_potencia_r_c"
                :alertMax="gauges.max_potencia_r_c"
                :title="$tc('Labels.ReactivePower', 2, { n: 'C' })"
                :value="gauges.potencia_r_c"
                unit="VAR"
              />
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showGauges">
          <div class="flex-1 p-4">
            <vx-card class="container-gauge">
              <gauge
                :min="limits.factor.min"
                :max="limits.factor.max"
                :alertMin="gauges.min_factor_a"
                :alertMax="gauges.max_factor_a"
                :title="$tc('Labels.Factor', 2, { n: 'A' })"
                :value="gauges.factor_a"
                unit=""
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.factor.min"
                :max="limits.factor.max"
                :alertMin="gauges.min_factor_b"
                :alertMax="gauges.max_factor_b"
                :title="$tc('Labels.Factor', 2, { n: 'B' })"
                :value="gauges.factor_b"
                unit=""
              />
            </vx-card>
          </div>
          <div class="flex-1 p-4">
              <vx-card class="container-gauge">
              <gauge
                :min="limits.factor.min"
                :max="limits.factor.max"
                :alertMin="gauges.min_factor_c"
                :alertMax="gauges.max_factor_c"
                :title="$tc('Labels.Factor', 2, { n: 'C' })"
                :value="gauges.factor_c"
                unit=""
              />
            </vx-card>
          </div>
        </div>
      </vs-tab>
      <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
        <div v-if="showAvg24">{{$t('Labels.Last24Hours')}}</div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 1)"
              :value="parseFloat(avg24.consumo_general[0].consumo_energia).toFixed(2)"
              unit="w"
              img="energy"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'A' })"
              :value="parseFloat(avg24.consumo_general[0].consumo_a).toFixed(2)"
              unit="w"
              img="energy"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'B' })"
              :value="parseFloat(avg24.consumo_general[0].consumo_b).toFixed(2)"
              unit="w"
              img="energy"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'C' })"
              :value="parseFloat(avg24.consumo_general[0].consumo_c).toFixed(2)"
              unit="w"
              img="energy"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
        </div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
              :min="parseFloat(avg24.min_corriente_a).toFixed(2)"
              :max="parseFloat(avg24.max_corriente_a).toFixed(2)"
              :value="parseFloat(avg24.avg_corriente_a).toFixed(2)"
              unit="A"
              img="corriente_a"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
              :min="parseFloat(avg24.min_corriente_b).toFixed(2)"
              :max="parseFloat(avg24.max_corriente_b).toFixed(2)"
              :value="parseFloat(avg24.avg_corriente_b).toFixed(2)"
              unit="A"
              img="corriente_b"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
              :min="parseFloat(avg24.min_corriente_c).toFixed(2)"
              :max="parseFloat(avg24.max_corriente_c).toFixed(2)"
              :value="parseFloat(avg24.avg_corriente_c).toFixed(2)"
              unit="A"
              img="corriente_c"
            />
          </div>
        </div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Voltage', 2, { n: 'A' })"
              :min="parseFloat(avg24.min_voltaje_a).toFixed(2)"
              :max="parseFloat(avg24.max_voltaje_a).toFixed(2)"
              unit="V"
              img="voltaje_a"
              :value="parseFloat(avg24.avg_voltaje_a).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Voltage', 2, { n: 'B' })"
              :min="parseFloat(avg24.min_voltaje_b).toFixed(2)"
              :max="parseFloat(avg24.max_voltaje_b).toFixed(2)"
              unit="V"
              img="voltaje_b"
              :value="parseFloat(avg24.avg_voltaje_b).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Voltage', 2, { n: 'C' })"
              :min="parseFloat(avg24.min_voltaje_c).toFixed(2)"
              :max="parseFloat(avg24.max_voltaje_c).toFixed(2)"
              unit="V"
              img="voltaje_c"
              :value="parseFloat(avg24.avg_voltaje_c).toFixed(2)"
            />
          </div>
        </div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Power', 2, { n: 'A' })"
              :min="parseFloat(avg24.min_potencia_a).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_a).toFixed(2)"
              unit="W"
              img="potencia_a"
              :value="parseFloat(avg24.avg_potencia_a).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Power', 2, { n: 'B' })"
              :min="parseFloat(avg24.min_potencia_b).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_b).toFixed(2)"
              unit="W"
              img="potencia_b"
              :value="parseFloat(avg24.avg_potencia_b).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Power', 2, { n: 'C' })"
              :min="parseFloat(avg24.min_potencia_c).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_c).toFixed(2)"
              unit="W"
              img="potencia_c"
              :value="parseFloat(avg24.avg_potencia_c).toFixed(2)"
            />
          </div>
        </div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ReactivePower', 2, { n: 'A' })"
              :min="parseFloat(avg24.min_potencia_r_a).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_r_a).toFixed(2)"
              unit="VAR"
              img="potencia_r_a"
              :value="parseFloat(avg24.avg_potencia_r_a).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ReactivePower', 2, { n: 'B' })"
              :min="parseFloat(avg24.min_potencia_r_b).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_r_b).toFixed(2)"
              unit="VAR"
              img="potencia_r_b"
              :value="parseFloat(avg24.avg_potencia_r_b).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.ReactivePower', 2, { n: 'C' })"
              :min="parseFloat(avg24.min_potencia_r_c).toFixed(2)"
              :max="parseFloat(avg24.max_potencia_r_c).toFixed(2)"
              unit="VAR"
              img="potencia_r_c"
              :value="parseFloat(avg24.avg_potencia_r_c).toFixed(2)"
            />
          </div>
        </div>
        <div class="flex" v-if="showAvg24">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Factor', 2, { n: 'A' })"
              :min="parseFloat(avg24.min_factor_a).toFixed(2)"
              :max="parseFloat(avg24.max_factor_a).toFixed(2)"
              img="factor_a"
              :value="parseFloat(avg24.avg_factor_a).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Factor', 2, { n: 'B' })"
              :min="parseFloat(avg24.min_factor_b).toFixed(2)"
              :max="parseFloat(avg24.max_factor_b).toFixed(2)"
              img="factor_b"
              :value="parseFloat(avg24.avg_factor_b).toFixed(2)"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Factor', 2, { n: 'C' })"
              :min="parseFloat(avg24.min_factor_c).toFixed(2)"
              :max="parseFloat(avg24.max_factor_c).toFixed(2)"
              img="factor_c"
              :value="parseFloat(avg24.avg_factor_c).toFixed(2)"
            />
          </div>
        </div>
        <div v-if="showToday">{{$t('Labels.Today')}}</div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy')"
              :value="parseFloat(energiesToday.consumo_energia || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'A' })"
              :value="parseFloat(energiesToday.consumo_a || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'B' })"
              :value="parseFloat(energiesToday.consumo_b || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'C' })"
              :value="parseFloat(energiesToday.consumo_c || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
        </div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',1, { n: 'A' })">
              <apexchart v-if="voltaje_a_today.loaded" type="line" height="350" :options="voltaje_a_today.options" :series="voltaje_a_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',1, { n: 'B' })">
              <apexchart v-if="voltaje_b_today.loaded" type="line" height="350" :options="voltaje_b_today.options" :series="voltaje_b_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',1, { n: 'C' })">
              <apexchart v-if="voltaje_c_today.loaded" type="line" height="350" :options="voltaje_c_today.options" :series="voltaje_c_today.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',1, { n: 'A' })">
              <apexchart v-if="corriente_a_today.loaded" type="line" height="350" :options="corriente_a_today.options" :series="corriente_a_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',1, { n: 'B' })">
              <apexchart v-if="corriente_b_today.loaded" type="line" height="350" :options="corriente_b_today.options" :series="corriente_b_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',1, { n: 'C' })">
              <apexchart v-if="corriente_c_today.loaded" type="line" height="350" :options="corriente_c_today.options" :series="corriente_c_today.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',1, { n: 'A' })">
              <apexchart v-if="potencia_a_today.loaded" type="line" height="350" :options="potencia_a_today.options" :series="potencia_a_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',1, { n: 'B' })">
              <apexchart v-if="potencia_b_today.loaded" type="line" height="350" :options="potencia_b_today.options" :series="potencia_b_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',1, { n: 'C' })">
              <apexchart v-if="potencia_c_today.loaded" type="line" height="350" :options="potencia_c_today.options" :series="potencia_c_today.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',1, { n: 'A' })">
              <apexchart v-if="potencia_a_r_today.loaded" type="line" height="350" :options="potencia_a_r_today.options" :series="potencia_a_r_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',1, { n: 'B' })">
              <apexchart v-if="potencia_b_r_today.loaded" type="line" height="350" :options="potencia_b_r_today.options" :series="potencia_b_r_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',1, { n: 'C' })">
              <apexchart v-if="potencia_c_r_today.loaded" type="line" height="350" :options="potencia_c_r_today.options" :series="potencia_c_r_today.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showToday">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',1, { n: 'A' })">
              <apexchart v-if="factor_a_today.loaded" type="line" height="350" :options="factor_a_today.options" :series="factor_a_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',1, { n: 'B' })">
              <apexchart v-if="factor_b_today.loaded" type="line" height="350" :options="factor_b_today.options" :series="factor_b_today.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',1, { n: 'C' })">
              <apexchart v-if="factor_c_today.loaded" type="line" height="350" :options="factor_c_today.options" :series="factor_c_today.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div>{{$t('Labels.LastWeek')}}</div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy')"
              :value="parseFloat(energiesWeek.consumo_energia || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'A' })"
              :value="parseFloat(energiesWeek.consumo_a || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'B' })"
              :value="parseFloat(energiesWeek.consumo_b || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
          <div class="flex-1 p-4">
            <statistics
              :title="$tc('Labels.Energy', 2, { n: 'C' })"
              :value="parseFloat(energiesWeek.consumo_c || 0).toFixed(2)"
              unit="Wh"
              img="kws"
              :subtitle="$tc('Labels.Accumulated')"
            />
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',2, { n: 'A' })">
              <apexchart v-if="voltaje_a_week.loaded" type="line" height="350" :options="voltaje_a_week.options" :series="voltaje_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',2, { n: 'B' })">
              <apexchart v-if="voltaje_b_week.loaded" type="line" height="350" :options="voltaje_b_week.options" :series="voltaje_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticVoltage',2, { n: 'C' })">
              <apexchart v-if="voltaje_c_week.loaded" type="line" height="350" :options="voltaje_c_week.options" :series="voltaje_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'A' })">
              <apexchart v-if="corriente_a_week.loaded" type="line" height="350" :options="corriente_a_week.options" :series="corriente_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'B' })">
              <apexchart v-if="corriente_b_week.loaded" type="line" height="350" :options="corriente_b_week.options" :series="corriente_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'C' })">
              <apexchart v-if="corriente_c_week.loaded" type="line" height="350" :options="corriente_c_week.options" :series="corriente_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'A' })">
              <apexchart v-if="corriente_a_week.loaded" type="line" height="350" :options="corriente_a_week.options" :series="corriente_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'B' })">
              <apexchart v-if="corriente_b_week.loaded" type="line" height="350" :options="corriente_b_week.options" :series="corriente_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticElectricCurrent',2, { n: 'C' })">
              <apexchart v-if="corriente_c_week.loaded" type="line" height="350" :options="corriente_c_week.options" :series="corriente_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',2, { n: 'A' })">
              <apexchart v-if="potencia_a_week.loaded" type="line" height="350" :options="potencia_a_week.options" :series="potencia_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',2, { n: 'B' })">
              <apexchart v-if="potencia_b_week.loaded" type="line" height="350" :options="potencia_b_week.options" :series="potencia_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticPower',2, { n: 'C' })">
              <apexchart v-if="potencia_c_week.loaded" type="line" height="350" :options="potencia_c_week.options" :series="potencia_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',2, { n: 'A' })">
              <apexchart v-if="potencia_r_a_week.loaded" type="line" height="350" :options="potencia_r_a_week.options" :series="potencia_r_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',2, { n: 'B' })">
              <apexchart v-if="potencia_r_b_week.loaded" type="line" height="350" :options="potencia_r_b_week.options" :series="potencia_r_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticReactivePower',2, { n: 'C' })">
              <apexchart v-if="potencia_r_c_week.loaded" type="line" height="350" :options="potencia_r_c_week.options" :series="potencia_r_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
        <div class="flex" v-if="showWeek">
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',2, { n: 'A' })">
              <apexchart v-if="factor_a_week.loaded" type="line" height="350" :options="factor_a_week.options" :series="factor_a_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',2, { n: 'B' })">
              <apexchart v-if="factor_b_week.loaded" type="line" height="350" :options="factor_b_week.options" :series="factor_b_week.data"></apexchart>
            </vx-card>
          </div>
          <div class="flex-1 p-3">
            <vx-card  :title="$tc('Labels.StatisticFactor',2, { n: 'C' })">
              <apexchart v-if="factor_c_week.loaded" type="line" height="350" :options="factor_c_week.options" :series="factor_c_week.data"></apexchart>
            </vx-card>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    </div>

  </div>

</div>

</template>

<script>
import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
import gauge from '@/components/gauge/gauge.vue'
import { empty } from '@/helpers.js'

export default {
  components: {
    apexchart,
    listItem,
    statistics,
    gauge
  },
  data () {
    return {
      response: [],
      log_limit: '5',
      uuid: this.$route.params.uuid,
      energy: {
        data: [{ data: [], name: 'Energía' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}w`
              }
            }
          }
        }
      },
      voltaje_a: {
        data: [{ data: [], name: 'Voltaje A' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}v`
              }
            }
          }
        }
      },
      voltaje_b: {
        data: [{ data: [], name: 'Voltaje B' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}v`
              }
            }
          }
        }
      },
      voltaje_c: {
        data: [{ data: [], name: 'Voltaje C' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}v`
              }
            }
          }
        }
      },
      corriente_a: {
        data: [{ data: [], name: 'Corriente A' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}A`
              }
            }
          }
        }
      },
      corriente_b: {
        data: [{ data: [], name: 'Corriente B' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}A`
              }
            }
          }
        }
      },
      corriente_c: {
        data: [{ data: [], name: 'Corriente C' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}A`
              }
            }
          }
        }
      },
      potencia_a: {
        data: [{ data: [], name: 'Potencia A' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}W`
              }
            }
          }
        }
      },
      potencia_b: {
        data: [{ data: [], name: 'Potencia B' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}W`
              }
            }
          }
        }
      },
      potencia_c: {
        data: [{ data: [], name: 'Potencia C' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}W`
              }
            }
          }
        }
      },
      potencia_r_a: {
        data: [{ data: [], name: 'Potencia Reactiva A' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} VAR`
              }
            }
          }
        }
      },
      potencia_r_b: {
        data: [{ data: [], name: 'Potencia Reactiva B' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} VAR`
              }
            }
          }
        }
      },
      potencia_r_c: {
        data: [{ data: [], name: 'Potencia Reactiva C' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} VAR`
              }
            }
          }
        }
      },
      energyWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_a: {
        data: [{ data: [], name: 'Factor A' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}`
              }
            }
          }
        }
      },
      factor_b: {
        data: [{ data: [], name: 'Factor B' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}`
              }
            }
          }
        }
      },
      factor_c: {
        data: [{ data: [], name: 'Factor C' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}`
              }
            }
          }
        }
      },
      energyToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      voltaje_a_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      voltaje_b_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      voltaje_c_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_a_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_b_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_c_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_a_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_b_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_c_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_a_r_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_b_r_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_c_r_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_a_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_b_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_c_today: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      options: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}w`
            }
          }
        }
      },
      optionsToday: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}w`
            }
          }
        }
      },
      voltaje_a_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      voltaje_b_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      voltaje_c_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_a_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_b_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      corriente_c_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_a_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_b_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_c_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_r_a_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_r_b_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      potencia_r_c_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_a_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_b_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      factor_c_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      urlDownload: '',
      avg24: {},
      energiesToday: null,
      energiesWeek: null,
      gauges: [],
      limits: [],
      showGauges: false,
      showAvg24: false,
      showWeek: false,
      showToday: false,
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    async getResponse () {
      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/energies/${this.uuid}/logs`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },
    async getDayStatictics () {
      this.$vs.loading()
      const params = {
        url: `modelo/energies/${this.uuid}/stadistics_24`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (response.data.data.length > 0) {
          this.energy.data[0].data.push(parseFloat(response.data.data[0].min_energia).toFixed(2))
          this.energy.data[0].data.push(parseFloat(response.data.data[0].avg_energia).toFixed(2))
          this.energy.data[0].data.push(parseFloat(response.data.data[0].max_energia).toFixed(2))

          this.voltaje_a.data[0].data.push(parseFloat(response.data.data[0].min_voltaje_a).toFixed(2))
          this.voltaje_a.data[0].data.push(parseFloat(response.data.data[0].avg_voltaje_a).toFixed(2))
          this.voltaje_a.data[0].data.push(parseFloat(response.data.data[0].max_voltaje_a).toFixed(2))

          this.voltaje_b.data[0].data.push(parseFloat(response.data.data[0].min_voltaje_b).toFixed(2))
          this.voltaje_b.data[0].data.push(parseFloat(response.data.data[0].avg_voltaje_b).toFixed(2))
          this.voltaje_b.data[0].data.push(parseFloat(response.data.data[0].max_voltaje_b).toFixed(2))

          this.voltaje_c.data[0].data.push(parseFloat(response.data.data[0].min_voltaje_c).toFixed(2))
          this.voltaje_c.data[0].data.push(parseFloat(response.data.data[0].avg_voltaje_c).toFixed(2))
          this.voltaje_c.data[0].data.push(parseFloat(response.data.data[0].max_voltaje_c).toFixed(2))

          this.corriente_a.data[0].data.push(parseFloat(response.data.data[0].min_corriente_a).toFixed(2))
          this.corriente_a.data[0].data.push(parseFloat(response.data.data[0].avg_corriente_a).toFixed(2))
          this.corriente_a.data[0].data.push(parseFloat(response.data.data[0].max_corriente_a).toFixed(2))

          this.corriente_b.data[0].data.push(parseFloat(response.data.data[0].min_corriente_b).toFixed(2))
          this.corriente_b.data[0].data.push(parseFloat(response.data.data[0].avg_corriente_b).toFixed(2))
          this.corriente_b.data[0].data.push(parseFloat(response.data.data[0].max_corriente_b).toFixed(2))

          this.corriente_c.data[0].data.push(parseFloat(response.data.data[0].min_corriente_c).toFixed(2))
          this.corriente_c.data[0].data.push(parseFloat(response.data.data[0].avg_corriente_c).toFixed(2))
          this.corriente_c.data[0].data.push(parseFloat(response.data.data[0].max_corriente_c).toFixed(2))

          this.potencia_a.data[0].data.push(parseFloat(response.data.data[0].min_potencia_a).toFixed(2))
          this.potencia_a.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_a).toFixed(2))
          this.potencia_a.data[0].data.push(parseFloat(response.data.data[0].max_potencia_a).toFixed(2))

          this.potencia_b.data[0].data.push(parseFloat(response.data.data[0].min_potencia_b).toFixed(2))
          this.potencia_b.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_b).toFixed(2))
          this.potencia_b.data[0].data.push(parseFloat(response.data.data[0].max_potencia_b).toFixed(2))

          this.potencia_c.data[0].data.push(parseFloat(response.data.data[0].min_potencia_c).toFixed(2))
          this.potencia_c.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_c).toFixed(2))
          this.potencia_c.data[0].data.push(parseFloat(response.data.data[0].max_potencia_c).toFixed(2))

          this.potencia_r_a.data[0].data.push(parseFloat(response.data.data[0].min_potencia_r_a).toFixed(2))
          this.potencia_r_a.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_r_a).toFixed(2))
          this.potencia_r_a.data[0].data.push(parseFloat(response.data.data[0].max_potencia_r_a).toFixed(2))

          this.potencia_r_b.data[0].data.push(parseFloat(response.data.data[0].min_potencia_r_b).toFixed(2))
          this.potencia_r_b.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_r_b).toFixed(2))
          this.potencia_r_b.data[0].data.push(parseFloat(response.data.data[0].max_potencia_r_b).toFixed(2))

          this.potencia_r_c.data[0].data.push(parseFloat(response.data.data[0].min_potencia_r_c).toFixed(2))
          this.potencia_r_c.data[0].data.push(parseFloat(response.data.data[0].avg_potencia_r_c).toFixed(2))
          this.potencia_r_c.data[0].data.push(parseFloat(response.data.data[0].max_potencia_r_c).toFixed(2))

          this.factor_a.data[0].data.push(parseFloat(response.data.data[0].min_factor_a).toFixed(2))
          this.factor_a.data[0].data.push(parseFloat(response.data.data[0].avg_factor_a).toFixed(2))
          this.factor_a.data[0].data.push(parseFloat(response.data.data[0].max_factor_a).toFixed(2))

          this.factor_b.data[0].data.push(parseFloat(response.data.data[0].min_factor_b).toFixed(2))
          this.factor_b.data[0].data.push(parseFloat(response.data.data[0].avg_factor_b).toFixed(2))
          this.factor_b.data[0].data.push(parseFloat(response.data.data[0].max_factor_b).toFixed(2))

          this.factor_c.data[0].data.push(parseFloat(response.data.data[0].min_factor_c).toFixed(2))
          this.factor_c.data[0].data.push(parseFloat(response.data.data[0].avg_factor_c).toFixed(2))
          this.factor_c.data[0].data.push(parseFloat(response.data.data[0].max_factor_c).toFixed(2))
        }
        this.energy.loaded = true
        this.voltaje_a.loaded = true
        this.voltaje_b.loaded = true
        this.voltaje_c.loaded = true
        this.corriente_a.loaded = true
        this.corriente_b.loaded = true
        this.corriente_c.loaded = true
        this.potencia_a.loaded = true
        this.potencia_b.loaded = true
        this.potencia_c.loaded = true
        this.potencia_r_a.loaded = true
        this.potencia_r_b.loaded = true
        this.potencia_r_c.loaded = true
        this.factor_a.loaded = true
        this.factor_b.loaded = true
        this.factor_c.loaded = true
        this.showAvg24 = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/energies/${this.uuid}/stadistics_week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.energyWeek.labels = []
        this.energyWeek.dataAvg = []
        this.energyWeek.dataMin = []
        this.energyWeek.dataMax = []
        this.energiesWeek = response.data.data.consumo_general[0]

        response.data.data.logs.forEach(function (item) {
          api.energyWeek.labels.push(item.day.split(' ')[0])
          api.energyWeek.dataAvg.push(parseFloat(item.avg_energia).toFixed(2))
          api.energyWeek.dataMin.push(parseFloat(item.min_energia).toFixed(2))
          api.energyWeek.dataMax.push(parseFloat(item.max_energia).toFixed(2))

          api.voltaje_a_week.labels.push(item.day.split(' ')[0])
          api.voltaje_a_week.dataAvg.push(parseFloat(item.avg_voltaje_a).toFixed(2))
          api.voltaje_a_week.dataMin.push(parseFloat(item.min_voltaje_a).toFixed(2))
          api.voltaje_a_week.dataMax.push(parseFloat(item.max_voltaje_a).toFixed(2))

          api.voltaje_b_week.labels.push(item.day.split(' ')[0])
          api.voltaje_b_week.dataAvg.push(parseFloat(item.avg_voltaje_b).toFixed(2))
          api.voltaje_b_week.dataMin.push(parseFloat(item.min_voltaje_b).toFixed(2))
          api.voltaje_b_week.dataMax.push(parseFloat(item.max_voltaje_b).toFixed(2))

          api.voltaje_c_week.labels.push(item.day.split(' ')[0])
          api.voltaje_c_week.dataAvg.push(parseFloat(item.avg_voltaje_c).toFixed(2))
          api.voltaje_c_week.dataMin.push(parseFloat(item.min_voltaje_c).toFixed(2))
          api.voltaje_c_week.dataMax.push(parseFloat(item.max_voltaje_c).toFixed(2))

          api.corriente_a_week.labels.push(item.day.split(' ')[0])
          api.corriente_a_week.dataAvg.push(parseFloat(item.avg_corriente_a).toFixed(2))
          api.corriente_a_week.dataMin.push(parseFloat(item.min_corriente_a).toFixed(2))
          api.corriente_a_week.dataMax.push(parseFloat(item.max_corriente_a).toFixed(2))

          api.corriente_b_week.labels.push(item.day.split(' ')[0])
          api.corriente_b_week.dataAvg.push(parseFloat(item.avg_corriente_b).toFixed(2))
          api.corriente_b_week.dataMin.push(parseFloat(item.min_corriente_b).toFixed(2))
          api.corriente_b_week.dataMax.push(parseFloat(item.max_corriente_b).toFixed(2))

          api.corriente_c_week.labels.push(item.day.split(' ')[0])
          api.corriente_c_week.dataAvg.push(parseFloat(item.avg_corriente_c).toFixed(2))
          api.corriente_c_week.dataMin.push(parseFloat(item.min_corriente_c).toFixed(2))
          api.corriente_c_week.dataMax.push(parseFloat(item.max_corriente_c).toFixed(2))

          api.potencia_a_week.labels.push(item.day.split(' ')[0])
          api.potencia_a_week.dataAvg.push(parseFloat(item.avg_potencia_a).toFixed(2))
          api.potencia_a_week.dataMin.push(parseFloat(item.min_potencia_a).toFixed(2))
          api.potencia_a_week.dataMax.push(parseFloat(item.max_potencia_a).toFixed(2))

          api.potencia_b_week.labels.push(item.day.split(' ')[0])
          api.potencia_b_week.dataAvg.push(parseFloat(item.avg_potencia_b).toFixed(2))
          api.potencia_b_week.dataMin.push(parseFloat(item.min_potencia_b).toFixed(2))
          api.potencia_b_week.dataMax.push(parseFloat(item.max_potencia_b).toFixed(2))

          api.potencia_c_week.labels.push(item.day.split(' ')[0])
          api.potencia_c_week.dataAvg.push(parseFloat(item.avg_potencia_c).toFixed(2))
          api.potencia_c_week.dataMin.push(parseFloat(item.min_potencia_c).toFixed(2))
          api.potencia_c_week.dataMax.push(parseFloat(item.max_potencia_c).toFixed(2))

          api.potencia_r_a_week.labels.push(item.day.split(' ')[0])
          api.potencia_r_a_week.dataAvg.push(parseFloat(item.avg_potencia_r_a).toFixed(2))
          api.potencia_r_a_week.dataMin.push(parseFloat(item.min_potencia_r_a).toFixed(2))
          api.potencia_r_a_week.dataMax.push(parseFloat(item.max_potencia_r_a).toFixed(2))

          api.potencia_r_b_week.labels.push(item.day.split(' ')[0])
          api.potencia_r_b_week.dataAvg.push(parseFloat(item.avg_potencia_r_b).toFixed(2))
          api.potencia_r_b_week.dataMin.push(parseFloat(item.min_potencia_r_b).toFixed(2))
          api.potencia_r_b_week.dataMax.push(parseFloat(item.max_potencia_r_b).toFixed(2))

          api.potencia_r_c_week.labels.push(item.day.split(' ')[0])
          api.potencia_r_c_week.dataAvg.push(parseFloat(item.avg_potencia_r_c).toFixed(2))
          api.potencia_r_c_week.dataMin.push(parseFloat(item.min_potencia_r_c).toFixed(2))
          api.potencia_r_c_week.dataMax.push(parseFloat(item.max_potencia_r_c).toFixed(2))

          api.factor_a_week.labels.push(item.day.split(' ')[0])
          api.factor_a_week.dataAvg.push(parseFloat(item.avg_factor_a).toFixed(2))
          api.factor_a_week.dataMin.push(parseFloat(item.min_factor_a).toFixed(2))
          api.factor_a_week.dataMax.push(parseFloat(item.max_factor_a).toFixed(2))

          api.factor_b_week.labels.push(item.day.split(' ')[0])
          api.factor_b_week.dataAvg.push(parseFloat(item.avg_factor_b).toFixed(2))
          api.factor_b_week.dataMin.push(parseFloat(item.min_factor_b).toFixed(2))
          api.factor_b_week.dataMax.push(parseFloat(item.max_factor_b).toFixed(2))

          api.factor_c_week.labels.push(item.day.split(' ')[0])
          api.factor_c_week.dataAvg.push(parseFloat(item.avg_factor_c).toFixed(2))
          api.factor_c_week.dataMin.push(parseFloat(item.min_factor_c).toFixed(2))
          api.factor_c_week.dataMax.push(parseFloat(item.max_factor_c).toFixed(2))
        })

        this.energyWeek.data = [
          {
            name: 'Mínimo',
            data: this.energyWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.energyWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.energyWeek.dataMax
          }
        ]

        this.voltaje_a_week.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_a_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_a_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_a_week.dataMax
          }
        ]

        this.voltaje_c_week.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_c_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_c_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_c_week.dataMax
          }
        ]

        this.voltaje_b_week.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_b_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_b_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_b_week.dataMax
          }
        ]

        this.corriente_a_week.data = [
          {
            name: 'Mínimo',
            data: this.corriente_a_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_a_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_a_week.dataMax
          }
        ]

        this.corriente_b_week.data = [
          {
            name: 'Mínimo',
            data: this.corriente_b_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_b_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_b_week.dataMax
          }
        ]

        this.corriente_c_week.data = [
          {
            name: 'Mínimo',
            data: this.corriente_c_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_c_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_c_week.dataMax
          }
        ]

        this.potencia_a_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_a_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_a_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_a_week.dataMax
          }
        ]

        this.potencia_b_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_b_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_b_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_b_week.dataMax
          }
        ]

        this.potencia_c_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_c_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_c_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_c_week.dataMax
          }
        ]

        this.potencia_r_a_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_r_a_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_r_a_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_r_a_week.dataMax
          }
        ]

        this.potencia_r_b_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_r_b_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_r_b_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_r_b_week.dataMax
          }
        ]

        this.potencia_r_c_week.data = [
          {
            name: 'Mínimo',
            data: this.potencia_r_c_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_r_c_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_r_c_week.dataMax
          }
        ]

        this.factor_a_week.data = [
          {
            name: 'Mínimo',
            data: this.factor_a_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_a_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_a_week.dataMax
          }
        ]

        this.factor_b_week.data = [
          {
            name: 'Mínimo',
            data: this.factor_b_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_b_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_b_week.dataMax
          }
        ]

        this.factor_c_week.data = [
          {
            name: 'Mínimo',
            data: this.factor_c_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_c_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_c_week.dataMax
          }
        ]

        this.energyWeek.options = this.getOptions()
        this.energyWeek.options.xaxis.categories = this.energyWeek.labels
        this.energyWeek.loaded = true

        this.voltaje_a_week.options = this.getOptions()
        this.voltaje_a_week.options.xaxis.categories = this.voltaje_a_week.labels
        this.voltaje_a_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_a_week.loaded = true

        this.voltaje_b_week.options = this.getOptions()
        this.voltaje_b_week.options.xaxis.categories = this.voltaje_b_week.labels
        this.voltaje_b_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_b_week.loaded = true

        this.voltaje_c_week.options = this.getOptions()
        this.voltaje_c_week.options.xaxis.categories = this.voltaje_c_week.labels
        this.voltaje_c_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_c_week.loaded = true

        this.corriente_a_week.options = this.getOptions()
        this.corriente_a_week.options.xaxis.categories = this.corriente_a_week.labels
        this.corriente_a_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_a_week.loaded = true

        this.corriente_b_week.options = this.getOptions()
        this.corriente_b_week.options.xaxis.categories = this.corriente_b_week.labels
        this.corriente_b_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_b_week.loaded = true

        this.corriente_c_week.options = this.getOptions()
        this.corriente_c_week.options.xaxis.categories = this.corriente_c_week.labels
        this.corriente_c_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_c_week.loaded = true

        this.potencia_a_week.options = this.getOptions()
        this.potencia_a_week.options.xaxis.categories = this.potencia_a_week.labels
        this.potencia_a_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_a_week.loaded = true

        this.potencia_b_week.options = this.getOptions()
        this.potencia_b_week.options.xaxis.categories = this.potencia_b_week.labels
        this.potencia_b_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_b_week.loaded = true

        this.potencia_c_week.options = this.getOptions()
        this.potencia_c_week.options.xaxis.categories = this.potencia_c_week.labels
        this.potencia_c_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_c_week.loaded = true

        this.potencia_r_a_week.options = this.getOptions()
        this.potencia_r_a_week.options.xaxis.categories = this.potencia_r_a_week.labels
        this.potencia_r_a_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }
        this.potencia_r_a_week.loaded = true

        this.potencia_r_b_week.options = this.getOptions()
        this.potencia_r_b_week.options.xaxis.categories = this.potencia_r_b_week.labels
        this.potencia_r_b_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }
        this.potencia_r_b_week.loaded = true

        this.potencia_r_c_week.options = this.getOptions()
        this.potencia_r_c_week.options.xaxis.categories = this.potencia_r_c_week.labels
        this.potencia_r_c_week.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }
        this.potencia_r_b_week.loaded = true
        this.potencia_r_c_week.loaded = true

        this.factor_a_week.options = this.getOptions()
        this.factor_a_week.options.xaxis.categories = this.factor_a_week.labels
        this.factor_a_week.loaded = true

        this.factor_b_week.options = this.getOptions()
        this.factor_b_week.options.xaxis.categories = this.factor_b_week.labels
        this.factor_b_week.loaded = true

        this.factor_c_week.options = this.getOptions()
        this.factor_c_week.options.xaxis.categories = this.factor_c_week.labels
        this.factor_c_week.loaded = true

        this.$vs.loading.close()
        this.showWeek = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getOptions () {
      return {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}`
            }
          }
        }
      }
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/energies/${this.uuid}/stadistics_today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.energyToday.labels = []
        this.energyToday.dataAvg = []
        this.energyToday.dataMin = []
        this.energyToday.dataMax = []
        this.energiesToday = response.data.data.consumo_general[0]

        response.data.data.logs.forEach(function (item) {
          /* api.energyToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.energyToday.dataAvg.push(parseFloat(item.avg_energia).toFixed(2))
          api.energyToday.dataMin.push(parseFloat(item.min_energia).toFixed(2))
          api.energyToday.dataMax.push(parseFloat(item.max_energia).toFixed(2)) */

          api.voltaje_a_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.voltaje_a_today.dataAvg.push(parseFloat(item.avg_voltaje_a).toFixed(2))
          api.voltaje_a_today.dataMin.push(parseFloat(item.min_voltaje_a).toFixed(2))
          api.voltaje_a_today.dataMax.push(parseFloat(item.max_voltaje_a).toFixed(2))

          api.voltaje_b_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.voltaje_b_today.dataAvg.push(parseFloat(item.avg_voltaje_b).toFixed(2))
          api.voltaje_b_today.dataMin.push(parseFloat(item.min_voltaje_b).toFixed(2))
          api.voltaje_b_today.dataMax.push(parseFloat(item.max_voltaje_b).toFixed(2))

          api.voltaje_c_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.voltaje_c_today.dataAvg.push(parseFloat(item.avg_voltaje_c).toFixed(2))
          api.voltaje_c_today.dataMin.push(parseFloat(item.min_voltaje_c).toFixed(2))
          api.voltaje_c_today.dataMax.push(parseFloat(item.max_voltaje_c).toFixed(2))

          api.corriente_a_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.corriente_a_today.dataAvg.push(parseFloat(item.avg_corriente_a).toFixed(2))
          api.corriente_a_today.dataMin.push(parseFloat(item.min_corriente_a).toFixed(2))
          api.corriente_a_today.dataMax.push(parseFloat(item.max_corriente_a).toFixed(2))

          api.corriente_b_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.corriente_b_today.dataAvg.push(parseFloat(item.avg_corriente_b).toFixed(2))
          api.corriente_b_today.dataMin.push(parseFloat(item.min_corriente_b).toFixed(2))
          api.corriente_b_today.dataMax.push(parseFloat(item.max_corriente_b).toFixed(2))

          api.corriente_c_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.corriente_c_today.dataAvg.push(parseFloat(item.avg_corriente_c).toFixed(2))
          api.corriente_c_today.dataMin.push(parseFloat(item.min_corriente_c).toFixed(2))
          api.corriente_c_today.dataMax.push(parseFloat(item.max_corriente_c).toFixed(2))

          api.potencia_a_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_a_today.dataAvg.push(parseFloat(item.avg_potencia_a).toFixed(2))
          api.potencia_a_today.dataMin.push(parseFloat(item.min_potencia_a).toFixed(2))
          api.potencia_a_today.dataMax.push(parseFloat(item.max_potencia_a).toFixed(2))

          api.potencia_b_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_b_today.dataAvg.push(parseFloat(item.avg_potencia_b).toFixed(2))
          api.potencia_b_today.dataMin.push(parseFloat(item.min_potencia_b).toFixed(2))
          api.potencia_b_today.dataMax.push(parseFloat(item.max_potencia_b).toFixed(2))

          api.potencia_c_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_c_today.dataAvg.push(parseFloat(item.avg_potencia_c).toFixed(2))
          api.potencia_c_today.dataMin.push(parseFloat(item.min_potencia_c).toFixed(2))
          api.potencia_c_today.dataMax.push(parseFloat(item.max_potencia_c).toFixed(2))

          api.potencia_a_r_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_a_r_today.dataAvg.push(parseFloat(item.avg_potencia_r_a).toFixed(2))
          api.potencia_a_r_today.dataMin.push(parseFloat(item.min_potencia_r_a).toFixed(2))
          api.potencia_a_r_today.dataMax.push(parseFloat(item.max_potencia_r_a).toFixed(2))

          api.potencia_b_r_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_b_r_today.dataAvg.push(parseFloat(item.avg_potencia_r_b).toFixed(2))
          api.potencia_b_r_today.dataMin.push(parseFloat(item.min_potencia_r_b).toFixed(2))
          api.potencia_b_r_today.dataMax.push(parseFloat(item.max_potencia_r_b).toFixed(2))

          api.potencia_c_r_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.potencia_c_r_today.dataAvg.push(parseFloat(item.avg_potencia_r_c).toFixed(2))
          api.potencia_c_r_today.dataMin.push(parseFloat(item.min_potencia_r_c).toFixed(2))
          api.potencia_c_r_today.dataMax.push(parseFloat(item.max_potencia_r_c).toFixed(2))

          api.factor_a_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.factor_a_today.dataAvg.push(parseFloat(item.avg_factor_a).toFixed(2))
          api.factor_a_today.dataMin.push(parseFloat(item.min_factor_a).toFixed(2))
          api.factor_a_today.dataMax.push(parseFloat(item.max_factor_a).toFixed(2))

          api.factor_b_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.factor_b_today.dataAvg.push(parseFloat(item.avg_factor_b).toFixed(2))
          api.factor_b_today.dataMin.push(parseFloat(item.min_factor_b).toFixed(2))
          api.factor_b_today.dataMax.push(parseFloat(item.max_factor_b).toFixed(2))

          api.factor_c_today.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.factor_c_today.dataAvg.push(parseFloat(item.avg_factor_c).toFixed(2))
          api.factor_c_today.dataMin.push(parseFloat(item.min_factor_c).toFixed(2))
          api.factor_c_today.dataMax.push(parseFloat(item.max_factor_c).toFixed(2))
        })

        this.energyToday.data = [
          {
            name: 'Mínimo',
            data: this.energyToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.energyToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.energyToday.dataMax
          }
        ]

        this.voltaje_a_today.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_a_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_a_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_a_today.dataMax
          }
        ]

        this.voltaje_b_today.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_b_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_b_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_b_today.dataMax
          }
        ]

        this.voltaje_c_today.data = [
          {
            name: 'Mínimo',
            data: this.voltaje_c_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.voltaje_c_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.voltaje_c_today.dataMax
          }
        ]

        this.corriente_a_today.data = [
          {
            name: 'Mínimo',
            data: this.corriente_a_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_a_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_a_today.dataMax
          }
        ]

        this.corriente_b_today.data = [
          {
            name: 'Mínimo',
            data: this.corriente_b_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_b_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_b_today.dataMax
          }
        ]

        this.corriente_c_today.data = [
          {
            name: 'Mínimo',
            data: this.corriente_c_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.corriente_c_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.corriente_c_today.dataMax
          }
        ]

        this.potencia_a_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_a_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_a_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_a_today.dataMax
          }
        ]

        this.potencia_b_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_b_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_b_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_b_today.dataMax
          }
        ]

        this.potencia_c_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_c_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_c_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_c_today.dataMax
          }
        ]

        this.potencia_a_r_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_a_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_a_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_a_today.dataMax
          }
        ]

        this.potencia_b_r_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_b_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_b_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_b_today.dataMax
          }
        ]

        this.potencia_c_r_today.data = [
          {
            name: 'Mínimo',
            data: this.potencia_c_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.potencia_c_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.potencia_c_today.dataMax
          }
        ]

        this.factor_a_today.data = [
          {
            name: 'Mínimo',
            data: this.factor_a_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_a_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_a_today.dataMax
          }
        ]

        this.factor_b_today.data = [
          {
            name: 'Mínimo',
            data: this.factor_b_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_b_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_b_today.dataMax
          }
        ]

        this.factor_c_today.data = [
          {
            name: 'Mínimo',
            data: this.factor_c_today.dataMin
          },
          {
            name: 'Promedio',
            data: this.factor_c_today.dataAvg
          },
          {
            name: 'Máximo',
            data: this.factor_c_today.dataMax
          }
        ]

        this.energyToday.options = this.getOptions()
        this.energyToday.options.xaxis.categories = this.energyToday.labels
        this.energyToday.loaded = true

        this.voltaje_a_today.options = this.getOptions()
        this.voltaje_a_today.options.xaxis.categories = this.voltaje_a_today.labels
        this.voltaje_a_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_a_today.loaded = true

        this.voltaje_b_today.options = this.getOptions()
        this.voltaje_b_today.options.xaxis.categories = this.voltaje_b_today.labels
        this.voltaje_b_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_b_today.loaded = true

        this.voltaje_c_today.options = this.getOptions()
        this.voltaje_c_today.options.xaxis.categories = this.voltaje_c_today.labels
        this.voltaje_c_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}V`
            }
          }
        }
        this.voltaje_c_today.loaded = true

        this.corriente_a_today.options = this.getOptions()
        this.corriente_a_today.options.xaxis.categories = this.corriente_a_today.labels
        this.corriente_a_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_a_today.loaded = true

        this.corriente_b_today.options = this.getOptions()
        this.corriente_b_today.options.xaxis.categories = this.corriente_b_today.labels
        this.corriente_b_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_b_today.loaded = true

        this.corriente_c_today.options = this.getOptions()
        this.corriente_c_today.options.xaxis.categories = this.corriente_c_today.labels
        this.corriente_c_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}A`
            }
          }
        }
        this.corriente_c_today.loaded = true

        this.potencia_a_today.options = this.getOptions()
        this.potencia_a_today.options.xaxis.categories = this.potencia_a_today.labels
        this.potencia_a_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_a_today.loaded = true

        this.potencia_b_today.options = this.getOptions()
        this.potencia_b_today.options.xaxis.categories = this.potencia_b_today.labels
        this.potencia_b_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_b_today.loaded = true

        this.potencia_c_today.options = this.getOptions()
        this.potencia_c_today.options.xaxis.categories = this.potencia_c_today.labels
        this.potencia_c_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}W`
            }
          }
        }
        this.potencia_c_today.loaded = true

        this.potencia_a_r_today.options = this.getOptions()
        this.potencia_a_r_today.options.xaxis.categories = this.potencia_a_r_today.labels
        this.potencia_a_r_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }

        this.potencia_a_r_today.loaded = true

        this.potencia_b_r_today.options = this.getOptions()
        this.potencia_b_r_today.options.xaxis.categories = this.potencia_b_r_today.labels
        this.potencia_b_r_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }
        this.potencia_b_r_today.loaded = true

        this.potencia_c_r_today.options = this.getOptions()
        this.potencia_c_r_today.options.xaxis.categories = this.potencia_c_r_today.labels
        this.potencia_c_r_today.options.tooltip = {
          y: {
            formatter (val) {
              return `${val}VAR`
            }
          }
        }
        this.potencia_c_r_today.loaded = true

        this.factor_a_today.options = this.getOptions()
        this.factor_a_today.options.xaxis.categories = this.factor_a_today.labels
        this.factor_a_today.loaded = true

        this.factor_b_today.options = this.getOptions()
        this.factor_b_today.options.xaxis.categories = this.factor_b_today.labels
        this.factor_b_today.loaded = true

        this.factor_c_today.options = this.getOptions()
        this.factor_c_today.options.xaxis.categories = this.factor_c_today.labels
        this.factor_c_today.loaded = true

        this.$vs.loading.close()
        this.showToday = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$tc('Labels.Energy'))
      headers.push(this.$tc('Labels.ElectricCurrent', 2, { n: 'A' }))
      headers.push(this.$tc('Labels.Voltage', 2, { n: 'A' }))
      headers.push(this.$tc('Labels.Power', 2, { n: 'A' }))
      headers.push(this.$tc('Labels.ReactivePower', 2, { n: 'A' }))
      headers.push(this.$tc('Labels.Factor', 2, { n: 'A' }))
      headers.push(this.$tc('Labels.ElectricCurrent', 2, { n: 'B' }))
      headers.push(this.$tc('Labels.Voltage', 2, { n: 'B' }))
      headers.push(this.$tc('Labels.Power', 2, { n: 'B' }))
      headers.push(this.$tc('Labels.ReactivePower', 2, { n: 'B' }))
      headers.push(this.$tc('Labels.Factor', 2, { n: 'B' }))
      headers.push(this.$tc('Labels.ElectricCurrent', 2, { n: 'C' }))
      headers.push(this.$tc('Labels.Voltage', 2, { n: 'C' }))
      headers.push(this.$tc('Labels.Power', 2, { n: 'C' }))
      headers.push(this.$tc('Labels.ReactivePower', 2, { n: 'C' }))
      headers.push(this.$tc('Labels.Factor', 2, { n: 'C' }))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        row.push(`${item.energia}W`)
        row.push(`${item.corriente_a}A`)
        row.push(`${item.voltaje_a}V`)
        row.push(`${item.potencia_a}W`)
        row.push(`${item.potencia_r_a}W`)
        row.push(item.factor_a)
        row.push(`${item.corriente_b}A`)
        row.push(`${item.voltaje_b}V`)
        row.push(`${item.potencia_b}W`)
        row.push(`${item.potencia_r_b}W`)
        row.push(item.factor_b)
        row.push(`${item.corriente_c}A`)
        row.push(`${item.voltaje_c}V`)
        row.push(`${item.potencia_c}W`)
        row.push(`${item.potencia_r_c}W`)
        row.push(item.factor_c)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/energies/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
